import { Portal } from '@radix-ui/react-popover';

export const PopoverPortal = Portal;
